interface ParsedItemId {
  readonly itemId: string;
  readonly subItemId?: string;
  readonly subSubItemId?: string;
}

export const parseItemId = (item: string): ParsedItemId => {
  const parts = item.split('.');

  if (item.endsWith('.')) {
    return {
      itemId: item,
    };
  }

  return {
    itemId: parts[0],
    subItemId: parts.length > 1 ? parts[1] : undefined,
    subSubItemId: parts.length > 2 ? parts[2] : undefined,
  };
};
